import React from 'react';

import style from './IframeTile.scss';

export const IframeTile = ({ widgetData }) => {
    const widgetURL = widgetData.imageURLs.c1x1;

    return <iframe src={widgetURL} className={style.iframeTile} />;
};
